var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-non-fly-pha-cmr.285b8352.png","uri@2x": __webpack_public_path__ + "icon-non-fly-pha-cmr.177715d1.png","uri@3x": __webpack_public_path__ + "icon-non-fly-pha-cmr.69353ae8.png",
    width: 20,
    height: 20
});